import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ThemeConsumer from '../ThemeConsumer'

class FloatLabelComponent extends Component {

  render() {
    const { theme, children, id, label, required } = this.props
    return (
      <div
        className={`${theme.floatLabel} ${theme.floatLabelPicker}`}
      >

        { children }

        <label
          htmlFor={id}
          className={theme.staticFloatingLabel}
        >
          <span>{label}</span>
          {required && (
            <span className={ theme.required }> *</span>
          )}
        </label>
      </div>
    )
  }
}

FloatLabelComponent.propTypes = {
  label: PropTypes.string.isRequired,
}

export default ThemeConsumer('UIFloatLabel')(FloatLabelComponent)


// WEBPACK FOOTER //
// ./src/shared/components/FloatLabelComponent/index.js